const translation = {
  password: 'Password',
  createInstance: 'Create Instance',
  searchPlaceholder: 'Search Instance Name',
  webAddress: 'Address',
  unknown: 'Unknown',
  empty_text: 'No Data',
  columns: {
    nameAndId: 'Name / ID',
    template: 'Template',
    status: 'Status',
    permission: 'Permission',
    resourceSpec: 'Resource Spec',
    image: 'Image',
    upsertTime: 'Created/Updated Time',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    tools: 'Quick Tools',
    action: 'Action',
  },
  operations: {
    log: 'Log',
    more: 'More',
    stop: 'Stop',
    start: 'Start',
    terminal: 'Terminal',
    saveImage: 'Save Image',
    editInstance: 'Edit Instance',
    deleteInstance: 'Delete Instance',
    createInstance: 'Create Instance',
    stopInstance: 'Stop Instance',
    startInstance: 'Start Instance',
  },
  network: {
    ip: 'IP Address',
    public: 'Public',
    container: 'Container',
    ssh: 'SSH',
  },
  permissionTag: {
    all_users: 'Public Shared',
    only_me: 'Private',
    all_team_members: 'Team Shared',
  },
}

export default translation
